var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-statistic',{attrs:{"icon":"shopping_cart","title":_vm.$t('customs.dashboard.productsPerSaleAvg'),"sub-title":_vm.subtitle,"value":_vm.periodDiffPositiveValue,"text":_vm.productPerSaleAverage.toFixed(2),"color":_vm.color,"caption":_vm.periodDiffIsInfinity
      ? ''
      : _vm.$t('customs.dashboard.previousPeriod') + ' ' + _vm.productPerSaleAveragePrevious.toFixed(2),"is-negative":Math.sign(_vm.percentagePeriodDiff) !== 1,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }